import { CS } from "../../../../base/utils/styler";

export const submitButtonStyle: CS = {
    boxShadow: '#0000002b 0px 2px 5px',
    padding: '10px 20px',
    margin: '20px 0',
    backgroundColor: '#007bff',
    color: 'white',
    borderRadius: '10px',
    cursor: '',
    position: 'absolute',
    opacity: '.5',
    filter: 'saturate(.2)',
    userSelect: 'none',
    pointerEvents: 'none',
    left: '0',
    '&:hover': {
        backgroundColor: '#007bffee',
    },
    '&:active': {
        transform: 'translateY(1px)',
        boxShadow: 'none',
    },
    '&:disabled': {
        backgroundColor: '#007bffe0',
        opacity: '0.7',
        cursor: '',
    },
}